// Module
var code = "<script>let $ctrl</script> <molecule-form-edit save=\"$ctrl.replaceContents\"> <molecule-panel-error error-type=\"update\" error-box-type=\"fixed\"></molecule-panel-error> <organ-edit-panel-record-change api-object=\"$ctrl.apiObject\"></organ-edit-panel-record-change> </molecule-form-edit> ";
// Exports
module.exports = code;